export var PRICING_PLAN_TYPES = {
  INSTANTLY_VIEWABLE_EPISODIC: 0,
  BROWSE_ONLY: 1,
  ORDERABLE: 2,
  INSTANTLY_VIEWABLE: 3
};